'use client';

import { cn } from '@/lib/shared/ui';
import { Check, Link } from 'lucide-react';
import React from 'react';
import { toastSuccess } from './toasts';

type Props = {
  slug: string;
};

export const HeadingLink = ({ slug }: Props) => {
  const [clicked, setClicked] = React.useState(false);

  const handleClick = () => {
    setClicked(true);

    toastSuccess('Link copied to clipboard');

    navigator.clipboard.writeText(`${window.location.origin}${window.location.pathname}#${slug}`);

    setTimeout(() => {
      setClicked(false);
    }, 5000);
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'top-0 opacity-0 -left-6 transition-all absolute h-full px-3',
        'group-hover:opacity-100 group-hover:-left-8',
      )}
    >
      <span className="flex items-center h-full">
        {clicked ? <Check className="text-green-700" size={16} /> : <Link size={16} />}
      </span>
    </button>
  );
};
